import { useMemo } from "react";

const useCheckJobsData = (isAllJobs, allJobs) => {
  return useMemo(() => {
    let tableData = [];
    let count = 0;

    if (isAllJobs && allJobs && allJobs.data) {
      count = allJobs.count || 0;
      tableData = allJobs.data || [];
    }

    return { tableData, count };
  }, [allJobs, isAllJobs]);
};

export default useCheckJobsData;